export default __webpack_public_path__ + "static/media/error.41b12111.svg";